<template>
    <div>
        <rkm-row>
            <rkm-col>
                <rkm-data-table
                    :fields="fields"
                    :repository="repositories.paciente"
                    :disabled-button-search="true"
                    :tbody-tr-class="rowClass"
                    ref="DataTable"
                    sort-by="nome"
                >
                    <template v-slot:cell(nome)="{ item }">

                        {{ item.nome }}

                        <template v-if="item.nomeSocial">
                            <template v-if="item.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                                <strong>({{ item.nomeSocial }})</strong>
                            </template>
                            <template v-else>
                                ({{ item.nomeSocial }})
                            </template>
                        </template>
                    </template>
                    <template v-slot:cell(dataNascimento)="row">
                        {{ row.value | formatDate }}
                    </template>
                    <template v-slot:cell(cpf)="row">
                        {{ row.value | formatCpf }}
                    </template>
                    <template v-slot:cell(cns)="row">
                        {{ row.value | formatCns }}
                    </template>
                    <template v-slot:cell(actions)="{ item }">
                        <rkm-button
                            @click.stop="handleCadastro(item)"
                            color="primary"
                            title="Visualizar"
                            small
                        >
                            <rkm-icon icon="search" />
                        </rkm-button>
                    </template>
                </rkm-data-table>
            </rkm-col>
        </rkm-row>
        <rkm-row class="mt-3">
            <rkm-col>
                <p class="m-0">
                    Linhas em <span class="danger">vermelho</span> representam pacientes em óbito.
                </p>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, stringCase } from '@/mixins'

// Filters.
import formats from '@/filters/formats'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import classificacao from '@/enums/cadastro/paciente/classificacao'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'

export default {
    created() {

        this.repositories = {
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            agendar: this.getConectaSusRepository('transportePaciente.agendar')
        }
    },
    data: () => ({
        fields: [
            {
                name: 'cadastroCidadao.nome',
                key: 'nome',
                label: 'Nome (Nome social)',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroCidadao.nomeSocial',
                key: 'nomeSocial',
                label: 'Nome social',
                searchable: true,
                sortable: true,
                visible: false
            },
            {
                name: 'cadastroCidadao.dataNascimento',
                key: 'dataNascimento',
                label: 'Data de nascimento',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroCidadao.nomeMae',
                key: 'nomeMae',
                label: 'Nome da mãe',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroPaciente.prontuario',
                key: 'prontuario',
                label: 'Prontuário municipal',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroCidadao.cpf',
                key: 'cpf',
                label: 'CPF',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroCidadao.cns',
                key: 'cns',
                label: 'CNS',
                searchable: true,
                sortable: true
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        repositories: {
            paciente: null,
        },
        enums: {
            preferenciaNome,
            classificacao,
            subclassificacao,
        },
        faltas: null
    }),
    filters: {
        formatDate: formats.formatDate,
        formatCns: formats.formatCns,
        formatCpf: formats.formatCpf,
    },
    methods: {
        ...mapActions([ 'setLoading', 'unsetLoading' ]),
        rowClass(item, type) {
            if(item && type === 'row') {
                if (item.obitoEm) {
                    return 'table-danger'
                }
            }
        },
        search(item) {

            if (item.classificacaoId !== this.enums.classificacao.MUNICIPE
                && item.classificacaoId !== this.enums.classificacao.PROVISORIO
                && item.classificacaoId !== this.enums.classificacao.OUTRO_MUNICIPIO) {

                    this.showValidationNotification(`Não é permitido realizar agendamento de transporte para a
                        classificação do paciente.`)

                    return false
            }

            if (this.faltas.limite && Number(this.faltas.total) > Number(this.faltas.limite)) {

                const confirm = async () => {

                    this.$router.push({ name: 'transporte-paciente-agendar-create', params: { id: item.id } })

                    return false
                }

                const msg = `O paciente excedeu o limite de <strong>${this.faltas.limite} faltas</strong> permitidas em viagens
                    agendadas durante um período de <strong>${this.faltas.periodo} meses</strong>. Deseja continuar?`

                this.showConfirmation(msg, confirm)

                return false
            }

            if (item.classificacaoId == this.enums.classificacao.PROVISORIO) {

                const confirm = async () => {

                    this.$router.push({ name: 'transporte-paciente-agendar-create', params: { id: item.id } })

                    return false
                }

                const msg = `Este paciente tem classificação provisória. Deseja continuar?`

                this.showConfirmation(msg, confirm)

                return false
            }

            if (item.classificacaoId == this.enums.classificacao.OUTRO_MUNICIPIO) {

                const confirm = async () => {

                    this.$router.push({ name: 'transporte-paciente-agendar-create', params: { id: item.id } })

                    return false
                }

                const msg = `Este paciente é de outro município. Deseja continuar?`

                this.showConfirmation(msg, confirm)

                return false
            }

            this.$router.push({ name: 'transporte-paciente-agendar-create', params: { id: item.id } })
        },
        handleCadastro(item) {

            this.setLoading()

            this.repositories.paciente.validCNS(this.camelObjectKeysToSnakeRecursive({pacienteId: item.id}))
                .then(response => {

                    if (!response.data.additionals.cnsValido && response.data.additionals.avisaCnsTemporarioInvalido) {

                        this.showWarningNotification('Paciente com CNS inválido. Registro não permitido.')
                        return false
                    }

                    if (item.subclassificacaoId === this.enums.subclassificacao.TEMPORARIO
                        && response.data.additionals.avisaCnsTemporarioInvalido) {

                            const confirm = async () => {

                                this.getFaltas(item)

                                return false
                            }

                            const msg = `Paciente com cadastro temporário. Deseja continuar?`

                            this.showConfirmation(msg, confirm)

                            return false
                    }

                    if (item.diasCadastroDesatualizado > 0) {

                        const confirm = async () => {

                            this.getFaltas(item)

                            return false
                        }

                        const msg = `Paciente com cadastro desatualizado há <strong>${item.diasCadastroDesatualizado}</strong>
                            dia(s). Deseja continuar?`

                        this.showConfirmation(msg, confirm)

                        return false
                    }

                    this.getFaltas(item)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getFaltas(item) {

            this.setLoading()

            this.repositories.agendar.getFaltasPaciente({
                'paciente_id': item.id,
            })
                .then(({ data }) => {

                    this.faltas = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading(this.$nextTick().then(() => this.search(item))))
        },
    },
    mixins: [ repository, error, stringCase ],
    props: {
        item: { type: Object, default: null }
    },
}
</script>

<style scoped>
.danger {
    color: var(--danger);
}
</style>